
<div class="mat-h1">Ertu viss um að eyða þessu skjali?</div>
<div fxLayout="row" fxLayoutAlign="space-between center">
<button mat-raised-button type="button" color="warning" (click)="cancel()">Hætta við</button>

<button mat-raised-button type="button" color="primary" (click)="confirm()"> Staðfesta</button>
</div>
